import React from 'react';
import classNames from 'classnames';

const Section = (props) => {
  const classes = classNames('c-section', props.customClass, {
    ...props.Modifiers,
  });

  const sectionClasses = classNames({
    'c-section__inner': true,
    'c-section__inner--double-column':
      props.Modifiers && props.Modifiers['c-section__double-column'],
  });

  return (
    <section className={classes}>
      <div className="row">
        <div className="columns">
          <div className={sectionClasses}>{props.children}</div>
        </div>
      </div>
    </section>
  );
};

export default Section;
